import { createAction, props } from '@ngrx/store';
import { ArchiveStatsModels } from '@models/archive-stats.models';
import { OnRangeSelectedResult } from '@ui';
import { ArchiveStatus } from '@models/archive.model';

export const resetToInitialState = createAction('[ARCHIVE-STATS] Reset to Initial state');

export const beforeGetArchiveStats = createAction('[ARCHIVE-STATS] Before Get Archive Stats');
export const getArchiveStats = createAction('[ARCHIVE-STATS] Get Archive Stats');

export const getArchiveStatsSuccess = createAction('[ARCHIVE-STATS] Get Archive Stats Success', props<{
  items: ArchiveStatsModels.Document[]
}>());
export const getArchiveStatsFail = createAction('[ARCHIVE-STATS] Get Archive Stats Fail');
export const setListLoader = createAction(
  '[ARCHIVE-STATS] Set list loader',
  props<{
    loading: boolean
  }>());

export const setCalendarFilter = createAction('[ARCHIVE-STATS] Set Calendar Filter', props<{
  date: OnRangeSelectedResult
}>());

export const resetEntities = createAction('[ARCHIVE-STATS] Reset Entities');

export const setStatusFilter = createAction('[ARCHIVE-STATS] Set Status Filter', props<{
  status: ArchiveStatus[]
}>());

export const setOrgIdFilter = createAction('[ARCHIVE-STATS] Set Org Id Filter', props<{
  orgId: string
}>());
